module.exports = __webpack_public_path__ + "img/icon-waitlist-black.d6d775ee.svg";